/* ─────────────────────── Navbar UI State ─────────────────────── */

export interface NavbarUIState {
  mobileMenuOpen: boolean;
  notificationModalOpen: boolean;
  switchModalOpen: boolean;
}

export type NavbarUIAction =
  | { type: 'MOBILE_MENU_OPEN' }
  | { type: 'MOBILE_MENU_CLOSE' }
  | { type: 'MOBILE_MENU_TOGGLE' }
  | { type: 'NOTIFICATION_OPEN' }
  | { type: 'NOTIFICATION_CLOSE' }
  | { type: 'SWITCH_MODAL_OPEN' }
  | { type: 'SWITCH_MODAL_CLOSE' }
  | { type: 'SWITCH_MODAL_OPEN_FROM_MOBILE' };

export const initialNavbarUIState: NavbarUIState = {
  mobileMenuOpen: false,
  notificationModalOpen: false,
  switchModalOpen: false,
};

export function navbarUIReducer(state: NavbarUIState, action: NavbarUIAction): NavbarUIState {
  switch (action.type) {
    case 'MOBILE_MENU_OPEN':
      return { ...state, mobileMenuOpen: true };
    case 'MOBILE_MENU_CLOSE':
      return { ...state, mobileMenuOpen: false };
    case 'MOBILE_MENU_TOGGLE':
      return { ...state, mobileMenuOpen: !state.mobileMenuOpen };
    case 'NOTIFICATION_OPEN':
      return { ...state, notificationModalOpen: true };
    case 'NOTIFICATION_CLOSE':
      return { ...state, notificationModalOpen: false };
    case 'SWITCH_MODAL_OPEN':
      return { ...state, switchModalOpen: true };
    case 'SWITCH_MODAL_CLOSE':
      return { ...state, switchModalOpen: false };
    case 'SWITCH_MODAL_OPEN_FROM_MOBILE':
      return { ...state, mobileMenuOpen: false, switchModalOpen: true };
    default:
      return state;
  }
}
